import {ApiClient} from "../../shared/api/apiClient.ts";
import {PaymentPackType} from "../../shared/types/PaymentPackType.ts";
import {PaymentProviderEnum} from "../../shared/types/PaymentProviderEnum.ts";
import {InvoiceResponse} from "../../shared/types/InvoiceResponseType.ts";

export class PaymentApi extends ApiClient {
    private readonly ENDPOINT = '/payment';
    constructor() {
        super()
    }

    public async getPaymentPacks(paymentProvider: PaymentProviderEnum) {
        const response = await this.get<PaymentPackType[]>(`${this.ENDPOINT}/get-payment-packages/${paymentProvider}`);
        return response;
    }

    public async makePayment(paymentPackId: string, paymentProvider: PaymentProviderEnum): Promise<InvoiceResponse> {
        const body = {
            paymentProvider,
        }
        const response: InvoiceResponse = await this.post(`${this.ENDPOINT}/create-invoice/${paymentPackId}`, body);
        return response;
    }
}
